export default {
  strict: true,
  namespaced: true,
  state: {
    quoteTime: '',
    startErrorLog: false,
    appLoader: false,
    appLoaderMsg: '',
    useLoadingMsg: false,
    useGroundLoadingMsg: false,
    widgetTab: 'd2d',
    verifiedMobile: [],
    currency: {
      code: 'USD',
      symbol: '$',
      value: 1,
      list: {},
      loading: false,
      edit: {
        code: 'USD',
        symbol: '$',
        value: 1
      },
      original: {
        code: 'USD',
        symbol: '$',
        value: 1
      }
    },
    default: {
      country: 'us',
      enabledLocation: false
    },
    hereMapsRouteDelay: 10,
    loginVia: '',
    lastPhoneOtp: '',
    lastCountryCode: '',
    defaultCountry: '',
    attemptCount: [],
    forceServiceLog: false
  },
  mutations: {
    setOtherData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    addVerifiedMobile (state, val) {
      let i = state.verifiedMobile.indexOf(val)
      if (i === -1) {
        state.verifiedMobile.push(val)
      }
    },
    setCurrencyData (state, data) {
      for (let field in data) {
        state.currency[field] = data[field]
      }
    },
    setDefaultData (state, data) {
      for (let field in data) {
        state.default[field] = data[field]
      }
    },
    addAttemptCount (state, val) {
      if (!state.attemptCount[val]) state.attemptCount[val] = 0
      state.attemptCount[val]++
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/other.js